export default "__VITE_ASSET__604d3942__"